// A volta do checkout (?welcome=1): confere o pagamento no ASAAS por até 20 s
// sem depender do webhook, e as tarjas do topo — trial acabando, ou a
// assinatura que venceu e rebaixou pro grátis (a Bia parou de responder).
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useLoja } from '../../shared/estado/loja';
import { avisar } from '../../shared/ui/avisos';
import { chaveDaAssinatura, useEstadoDaAssinatura, useStatusDoPlano, verificarPagamento } from './api';
import { tarjaDaAssinatura } from './regras';
import estilos from './BoasVindas.module.css';

export function BoasVindas() {
  const [params, setParams] = useSearchParams();
  const consultas = useQueryClient();
  const tenantId = useLoja((s) => s.tenantId) ?? '';
  const estado = useEstadoDaAssinatura();
  // O plano EFETIVO decide o "venceu" (isento e founder nunca veem a tarja).
  const plano = useStatusDoPlano();
  const [conferindo, setConferindo] = useState(() => params.has('welcome'));

  useEffect(() => {
    if (!params.has('welcome')) return;
    let vivo = true;
    (async () => {
      for (let i = 0; i < 10 && vivo; i++) {
        await new Promise((r) => setTimeout(r, 2000));
        try { const v = await verificarPagamento(); if (v.ok && v.paid) break; } catch { /* tenta de novo */ }
      }
      if (!vivo) return;
      await consultas.invalidateQueries({ queryKey: chaveDaAssinatura(tenantId) });
      setConferindo(false);
      const p = new URLSearchParams(params); p.delete('welcome'); setParams(p, { replace: true });
      avisar('Pagamento conferido. Bem-vinda! 💚');
    })();
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sem o plano efetivo ainda, nada de tarja: mostrar "venceu" por um instante
  // para quem é isento seria o mesmo defeito, só que piscando.
  // E sem o `plano_efetivo` na resposta, também não: a tarja mora na casca do
  // painel, e uma resposta torta aqui não pode derrubar a tela inteira.
  const efetivo = plano.data?.plano_efetivo;
  const tarja = estado.data && efetivo ? tarjaDaAssinatura(estado.data, efetivo) : null;
  return (
    <>
      {conferindo && <div className={estilos.cortina} role="status"><div className={`vidro ${estilos.cartao}`}><div className={estilos.giro} aria-hidden="true" /><div className={estilos.titulo}>Confirmando seu pagamento...</div><div className="apoio">Isso pode levar alguns segundos. Não feche essa página.</div></div></div>}
      {tarja && <Link to={tarja.destino} className={`${estilos.tarja} ${tarja.tom === 'perigo' ? estilos.tarjaPerigo : ''}`}>{tarja.texto}</Link>}
    </>
  );
}
